import React, { useState, useEffect } from 'react'
import { Steps, Space} from 'antd'
import { useJKspListQuery, useJKspjdListQuery } from '../../store/DianShangYeWuApi';
function LoanNodeEdit(props) {
    const [items, setItems] = useState([])
    const {data, isSuccess} = useJKspListQuery({jk_sp_jk_id:props.jk_id},{skip:!props.jk_id})
    const {data:spjdData, isSuccess:spjdIsSuccess} = useJKspjdListQuery({jk_spjd_qy_id:props.qy_id,jk_spjd_user_id:props.user_id},{skip:!props.user_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            const sortedData = [...data.Result].sort((a, b) => {
                return a.jk_sp_xuhao - b.jk_sp_xuhao;
            })
            const arr = sortedData.map((item) => ({
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.jk_sp_jd_name}</span>       ,
                content:<Space orientation='vertical' size={1}>
                                <span>
                                {(item.jk_sp_state==='3' && item.jk_sp_jd_name==='抄送') && <span style={{color:"#000"}}>未读：</span>}
                                {(item.jk_sp_state==='3' && item.jk_sp_jd_name==='审批') && <span style={{color:"green"}}>已同意{item.jk_sp_content? '：'+item.jk_sp_content :''}</span>}
                                {(item.jk_sp_state==='4' && item.jk_sp_jd_name==='审批') && <span style={{color:"red",fontWeight:"bold"}}>已驳回{item.jk_sp_content? '：'+item.jk_sp_content :''}</span>}
                            </span>
                            <span style={(item.jk_sp_state==='3' || item.jk_sp_state==='4' || item.jk_sp_state==='5') ? {color:'#000'} : {}}>{item.jk_sp_yh_name} {item.jk_sp_state_time} </span>
                        </Space>,
            }))
            setItems([{
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                content:<span style={{fontSize:"12px"}}>{props.jk_uname} {props.jk_ctime}</span>,
            },
            {
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                content:<span style={{fontSize:"12px"}}>{props.jk_uname} {props.jk_state_time}</span>,
            },...arr]);
        }else{
            if(spjdIsSuccess && spjdData.Status === 'success'){
                const sortedData = [...spjdData.Result].sort((a, b) => {
                    return a.jk_spjd_xuhao - b.jk_spjd_xuhao;
                })
                const arr = sortedData.map((item) => ({
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.jk_spjd_name}</span>       ,
                    content:<span style={{fontSize:"12px"}}>{item.jk_spjd_yh_name}</span>,
                }))
                setItems([{
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                    content:<span style={{fontSize:"12px"}}>{props.jk_uname} {props.jk_ctime}</span>,
                },
                {
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                    content:<span style={{fontSize:"12px"}}>{props.jk_uname}{props.jk_state_time}</span>,
                },...arr]);
            }else{
                setItems([]);
            }
        }
        
        
    },[data, isSuccess,spjdData, spjdIsSuccess,props])
    return (
        <Steps 
            items={items} 
            current={1} 
            size="small" 
            titlePlacement="vertical"
        />
    )
}

export default LoanNodeEdit